export enum ReviewsPageTabs {
  All = 'all',
  Positive = 'positive',
  Average = 'average',
  Negative = 'negative',
  NoAnswer = 'noAnswer',
}
